// The design's "Similar · Hilton" panel has no merchant-similarity
// endpoint in M1 (execution plan §9.9). Rendered as an honest inline note
// rather than a fabricated related-transaction list.
export function SimilarList({ merchantName }: { merchantName: string }) {
  return (
    <div data-testid="similar-list" className="mt-3 text-xs text-muted-foreground">
      <div className="font-semibold text-foreground">Similar · {merchantName}</div>
      <p className="mt-1">Related-transaction lookup ships in a later milestone.</p>
    </div>
  );
}

export default SimilarList;
